<template>
  <default-list-actions
    :item="item"
    :hide-view="true"
    :hideRemove="!$store.getters.hasAccessTo('itineraries:delete_template')"
    @deleteItem="onDeleteItem"
    @editItem="editItem"
    delete-warning="WARNING!! You are about to delete a Template. Continue?"
  >
    <template slot="extraButton">
      <div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon small @click="onShowTemplateSettings(item)">
              <v-icon color="primary" small>mdi-playlist-plus</v-icon>
            </v-btn>
          </template>
          <span>Create Itinerary</span>
        </v-tooltip>
        <v-tooltip
          bottom
          v-if="$store.getters.hasAccessTo('itineraries:copy_template')"
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon small @click="cloneItem(item)">
              <v-icon color="primary" small>mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <span>Copy</span>
        </v-tooltip>
      </div>
      <div>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon small @click="editItemContents(item)">
              <v-icon color="blue" small>mdi-camera</v-icon>
            </v-btn>
          </template>
          <span>Template Contents</span>
        </v-tooltip>
      </div>
    </template>
  </default-list-actions>
</template>

<script>
import DefaultListActions from "../shared/DefaultListActions.vue";
export default {
  components: { DefaultListActions },
  name: "template-list-actions",

  props: {
    item: {
      type: Object,
      default: () => null,
    },
  },

  computed: {
    itemData() {
      return this.params ? { ...this.params.data } : { ...this.item };
    },
  },

  methods: {
    editItem() {
      if (this.params) {
        this.params.context.componentParent.editItem(this.itemData);
      } else {
        this.$emit("editItem", this.item);
      }
    },
    editItemContents() {
      if (this.params) {
        this.params.context.componentParent.editItemContents(this.itemData);
      } else {
        this.$emit("editItemContents", this.item);
      }
    },
    onShowTemplateSettings(item) {
      if (this.params) {
        this.params.context.componentParent.onShowTemplateSettings(
          this.itemData
        );
      } else {
        this.$emit("showTemplateSettings", item);
      }
    },
    cloneItem(item) {
      if (this.params) {
        this.params.context.componentParent.cloneItem(this.itemData);
      } else {
        this.$emit("cloneItem", item);
      }
    },
    onDeleteItem() {
      if (this.params) {
        this.params.context.componentParent.deleteItem(this.itemData);
      } else {
        this.$emit("deleteItem", this.item);
      }
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/templates/TemplateListActions.vue